import { Spin as AntSpin } from "antd";
import { bool } from "prop-types";

const Spin = ({ loading = true }) => (
  <AntSpin
    spinning={loading}
    style={{ width: "100%", marginTop: "20%" }}
    size="large"
  />
);

Spin.propTypes = {
  loading: bool,
};

export default Spin;
